import { Component } from '@angular/core';
import { EntityCrud } from '../../../shared/working/entity-crud/entity-crud';
import { ENTITY_CONFIGS } from '../entity-configs';

@Component({
  imports: [EntityCrud],
  selector: 'app-md-a1fecd50',
  styleUrl: './md-a1fecd50.css',
  templateUrl: './md-a1fecd50.html',
})
export class MdA1fecd50 { readonly config = ENTITY_CONFIGS['a1fecd50']; }
